import InlineMessage from '@ingka/inline-message';
import warningTriangleIcon from '@ingka/ssr-icon/paths/warning-triangle';
import { translate } from '@repo/phrase';
import { Container } from '@repo/ui/container';

interface Props {
    type: 'order' | 'draft' | 'quote';
}

export const NoOrderId = ({ type }: Props) => {
    let title = '';
    if (type === 'order') {
        title = translate('order_no_order_id');
    }
    if (type === 'draft') {
        title = translate('order_no_draft_id');
    }
    if (type === 'quote') {
        title = translate('order_no_quotation_id');
    }

    return (
        <Container testId="no-order-id" padding>
            <InlineMessage
                title={title}
                body={translate('order_no_id')}
                ssrIcon={warningTriangleIcon}
                variant="cautionary"
            />
        </Container>
    );
};
